var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BbTable',{attrs:{"tableConfig":_vm.tableConfig}})
}
var staticRenderFns = []

export { render, staticRenderFns }